import { UPLOAD_QUOTE } from '../constants/actionTypes'

export const uploadQuote = (upload) => async (dispatch) => {
    try {
        dispatch({ type: UPLOAD_QUOTE, payload: upload })
    } catch (error) {
        console.log(error)
    }
}